import { Signout } from "../demo/SignIn"
import AppBar from '@mui/material/AppBar'
import CssBaseline from '@mui/material/CssBaseline'
import Toolbar from '@mui/material/Toolbar'
import GlobalStyles from '@mui/material/GlobalStyles'
import Container from '@mui/material/Container'
import ContextSelector from "../components/ContextSelector"
import { Avatar, Box, Button, Divider, Menu } from "@mui/material"
import { blue } from "@mui/material/colors"
import { useAvatar } from "../atoms/auth"
import AmbientIndicator from '../components/AmbientIndicator'
import { useAmbientInfo } from '../utils/hooks'
import constants, { headerHeight } from '../Constants'
import { Notifications } from './Notifications'
import { useNavigate } from 'react-router-dom'
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';
import { useUser } from '../atoms'
import { useTranslation } from "react-i18next"
import { userImageDataSelector, userSettingSelected } from '../atoms/userSetting'
import { useRecoilValue } from 'recoil'
import { useRef, useState } from "react"

const useAvatarStyle = makeStyles((theme: Theme) => ({
    root: {
        marginLeft: '1rem'
    },
    identityAvatar: {
        color: theme.palette?.getContrastText(blue[600]),
        backgroundColor: blue[600],
        cursor: 'pointer'
    },
    paper: {
        marginRight: '2px' //theme.spacing(2)
    },
    menu: {
        paddingTop: 0
    },
    appBar: {
        padding: '3px', //theme.spacing(3),
        backgroundColor: '#fff',
        color: 'rgba(0, 0, 0, 0.7)',
        fontWeight: 400,
        fontSize: '0.875rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
}));

export const HeaderSection = () => {
    const avatar = useAvatar()
    const ambientInfo = useAmbientInfo()
    const navigate = useNavigate()
    const avatarRef = useRef<any>(null);
    const [open, setOpen] = useState(false);
    const classes = useAvatarStyle();
    const user = useUser();
    const { t } = useTranslation();
    const userSetting = useRecoilValue(userSettingSelected)
    const userImage: string = useRecoilValue(userImageDataSelector)

    // console.log('userSetting in Header', userSetting)
    const handler = {
        toggle: () => { setOpen(prevOpen => !prevOpen) },
        close: (event: React.MouseEvent<EventTarget>) => {
            if (avatarRef.current && avatarRef.current.contains(event.target as HTMLElement)) {
                return;
            }
            setOpen(false);
        },
        settings: async () => {
            //let item: Principal = await principalActions.find(identity.id);
            //principalActions.itemSelected(item, 0);                
            navigate('setting/' + user?.name);
            setOpen(false);
        }
    }

    // useEffect(() => {
    //     console.log('userSetting', userSetting)
    // }, [userImage, userSetting])
    return (
        <>
            <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
            <CssBaseline />
            <AppBar position="fixed" color="default" elevation={1}
                sx={(theme) => ({ borderBottom: `1px solid ${theme.palette.divider}`, backgroundColor: (theme) => theme.palette.secondary.main, color: '#EDEFF0', height: headerHeight, padding: 0, zIndex: theme.zIndex.drawer + 1 })}>
                <Toolbar sx={{ flexWrap: 'wrap' }}>
                    <Container sx={{ flexGrow: 1, marginLeft: 0, width: 'auto' }}>
                        <img src="/MySixtemaNew.svg" alt='mySixtema' width={160} onClick={() => navigate("/")} />
                    </Container>
                    <ContextSelector />
                    <Notifications />
                    <Avatar sx={{ m: 1, bgcolor: blue[600] }} src={userImage} title={avatar.name} ref={avatarRef} onClick={handler.toggle}>{avatar.initials}</Avatar>
                    <Menu
                        anchorEl={avatarRef.current}
                        keepMounted
                        open={open}
                        MenuListProps={{ disablePadding: true }}
                        className={classes.menu}
                        onClose={handler.close}
                    >
                        <Box className={classes.appBar}>
                            <Avatar className={classes.identityAvatar}>
                                {userSetting.avatar ? <img src={userImage} width="40" alt='Avatar' /> : avatar.initials}
                            </Avatar>
                            <Box sx={{ marginTop: '1rem', fontWeight: 500 }}>{`${user?.name}`}</Box>
                            <Box style={{ fontSize: '0.75rem' }}>{user?.mail !== undefined ? `${user?.mail}` : ''}</Box>
                        </Box>
                        <Divider />
                        <Box sx={{ margin: '0.5em' }}></Box>
                        {/* <MenuItem onClick={handler.settings}>{t('common:settings')}</MenuItem>  */}
                        <Box sx={{ padding: '0.5rem 1rem 1rem 1rem' }}>
                            <Button style={{ width: '100%' }} onClick={handler.settings}>{t('impostazioni')}</Button>
                        </Box>
                    </Menu>
                    <Signout href={constants.logoutUrl} variant="text" />
                </Toolbar>
            </AppBar>
            <Box sx={{ height: headerHeight }}></Box>
            <AmbientIndicator {...ambientInfo} />
        </>
    )
}


